module.exports = cacheman-redis;